<template>
    <span>{{ formatDateTime(input, format) }}</span>
</template>

<script>
import CommunityTimezoneMixin from '@/mixins/CommunityTimezoneMixin';

export default {
    name: 'CommunityDateTimeDisplay',
    mixins: [CommunityTimezoneMixin],
    props: {
        input: {
            required: true,
        },

        format: {
            type: String,
        },
    },
};
</script>

<style scoped></style>
